import { SimpleGrid, Flex, Text, Image, Center } from "@chakra-ui/react";
import React, { memo } from "react";
import { getAlohainfoWhatData } from "@/constants/alohainfo-contants";
export default memo(function WhatComponent() {
   var list = getAlohainfoWhatData();
   return (
      <>
         <Center mt={"120px"} w={"1280px"} mx={"auto"}>
            <Text fontSize={34} color={"green.500"} mr={"17px"}>
               What
            </Text>
            <Text fontSize={34}>are the key features of AlohaBots?</Text>
         </Center>
         <SimpleGrid columns={3} gridGap={"20px"} w={"1280px"} mx={"auto"} mt={"100px"} mb={"100px"}>
            {list.map((item) => {
               return (
                  <Flex flexDir={"column"} h={"230px"} pl={"27px"} key={item.title}>
                     <Image userSelect="none" src={process.env.REACT_APP_PUBLIC_URL + item.icon} boxSize={"36px"} />
                     <Text fontSize={20} fontFamily={'Arial-BoldMT'} mt={"30px"}>
                        {item.title}
                     </Text>
                     <Text fontSize={20} lineHeight={"26px"} color={"#333"} mt={"20px"}>
                        {item.info}
                     </Text>
                  </Flex>
               );
            })}
         </SimpleGrid>
      </>
   );
});
